<template>
    <v-card class="mx-auto" width="100%">
      <v-card-title>{{ $t("page.report.rocky_mountain_registrant_report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex pb-0" cols="12" sm="6">
              <v-autocomplete 
                v-model="eventSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id"
                multiple
                dense outlined 
                :label="$t('page.report.label-event-memberships-select-event')" 
                return-object
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">({{ $t("page.report.filter_selections") }}: {{ eventSelected.length }} )</span>
                </template>
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex py-0" cols="12" sm="6">&nbsp;</v-col>
            <v-col class="d-flex pt-0" cols="12" sm="6">
                <v-card>
                    <v-btn 
                        v-if="isShowBtn"
                        color="blue-grey" 
                        class="ma-1 white--text" 
                        @click="handleDownloadPDF()"
                    >
                    {{ $t("page.report.label-pdf-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn 
                        v-if="isShowBtn"
                        color="blue-grey" 
                        class="ma-1 white--text" 
                        @click="handleDownloadCSV()"
                    >
                    {{ $t("page.report.label-csv-btn") }}
                    <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                    </v-btn>
                    <v-btn color="blue-grey" class="ma-1 white--text" @click="getReport()">
                    {{ $t("page.report.label-load-report-btn") }}
                    <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
</template>

<script>
import ReportsService from '@/services/ReportsService';
import { mapState } from 'vuex';
import reportsMixin from '@/mixins/reports.js';

export default {
    name: 'RockyMountainRegistrantReport',
    mixins: [reportsMixin],
    props: {
    },
    data() {
        return {
            //eventItems: eventItems,
            raceItems: []
        };
    },
    computed: {
        isShowBtn() {
            return this.tabulatorData?.length > 0;
        },
        tabulatorOptions() {
            return {
                layout: "fitColumns",
                placeholder: this.$t("common.no_data_set"),
                height: 500,
                printAsHtml: true,
                downloadRowRange: "all",
                layoutColumnsOnNewData: true,
                columns: [
                {
                    title: this.$t("page.report.label-event-memberships-firstName"),
                    field: "firstName",
                    sorter: "string",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-lastName"),
                    field: "lastName",
                    sorter: "string",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ", 
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-mailingAddress"),
                    field: "address",
                    sorter: "string",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-city"),
                    field: "city",
                    sorter: "string",
                    headerFilter: "select",
                    ...this.getCaseInsensitiveMultiselectFilter("city"),
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-state"),
                    field: "state",
                    sorter: "string",
                    headerFilter: "select",
                    ...this.getCaseInsensitiveMultiselectFilter("state"),
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-zipcode"),
                    field: "zip",
                    sorter: "string",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                {
                    title: this.$t("page.report.label-event-memberships-emailAddress"),
                    field: "emailAddress",
                    sorter: "string",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                    minWidth: 100,
                    formatter: "textarea",
                    sorterParams:{
                    alignEmptyValues: "bottom"
                    }
                },
                ],
            };
        },
        ...mapState({
            event: state => state.reports.reports.events.eventSelected,
            races: state => state.reports.reports.events.racesSelected,
            data: state => state.reports.reports.events.data,
            eventItems: (state) => state.reports.eventItems,
        }),
        eventSelected: {
            get() {
                return this.event;
            },
            set(value) {
                this.$store.commit('reports/SET_REPORTS', { type: 'events', index: 'eventSelected', value });
            }
        },
        racesSelected: {
            get() {
                return this.races;
            },
            set(value) {
                this.$store.commit('reports/SET_REPORTS', { type: 'events', index: 'racesSelected', value });
            }
        },
        tabulatorData: {
            get() {
                return this.data;
            },
            set(value) {
                this.$store.commit('reports/SET_REPORTS', { type: 'events', index: 'data', value });
            }
        }
    },
    methods: {
        normalizeCaseValue(value) {
            return (value ?? "")
                .toString()
                .normalize("NFKC")
                .replace(/[\u200B-\u200D\uFEFF]/g, "")
                .replace(/\s+/g, " ")
                .trim()
                .toUpperCase();
        },
        getCaseInsensitiveMultiselectFilter(field) {
            return {
                headerFilterFunc: (headerValue, rowValue) => {
                    const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
                    if (!selectedValues.length) return true;
                    const normalizedRowValue = this.normalizeCaseValue(rowValue);
                    return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
                },
                headerFilterParams: {
                    values: () => {
                        const unique = new Set();
                        (this.tabulatorData || []).forEach((row) => {
                            const normalized = this.normalizeCaseValue(row?.[field]);
                            if (normalized) unique.add(normalized);
                        });
                        return Array.from(unique).sort();
                    },
                    sortValuesList: "asc",
                    multiselect: true
                }
            };
        },
        handleDownloadPDF() {
            this.downloadAsPDFFromMixin('tabulator', 'tabulatorData');
        },
        handleDownloadCSV() {
            this.downloadAsCSVFromMixin('tabulator', 'tabulatorData');
        },
        getReport() {
            if(this.eventSelected.length > 0) {
                const eventIds = this.eventSelected.map(item => item.id);
                this.getRockyMountainRegistrant(eventIds);
            } else {
                this.tabulatorData = [];
                this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-races-required'));
                this.$store.commit('reports/SET_SHOW_ALERT', true);
            }
        },
        async getRockyMountainRegistrant(eventIds) {
            const tabulatorInstance = this.$refs.tabulator.getInstance();
            tabulatorInstance.clearHeaderFilter();
            if(eventIds.length > 0) {
                const response = await ReportsService.getRockyMountainReport({ eventId: eventIds });
                this.tabulatorData = response;
            }
        },
        async getEvents() {
            const response = await ReportsService.getEventsHasRaces();
            this.eventItems = response.map(item => ({
                id: item.id,
                text: this.$escapeHtml.decode(item.eventName)
            }));
        },
        async getRaces() {
            if(this.eventSelected?.id) {
                const response = await ReportsService.getRacesForEvent(this.eventSelected.id);
                this.raceItems = response.map(item => ({
                    id: item.id,
                    text: this.$escapeHtml.decode(item.raceName)
                }));
            } else {
                this.raceItems = [];
            }
        }
    }
};
</script>